module.exports = __webpack_public_path__ + "img/5.6235922f.jpg";